import type { ReactNode, JSX } from "react";

import type { IDescriptionDropdownItemProps } from "@similarweb/ui-components";
import { DescriptionDropdownItem, Dropdown } from "@similarweb/ui-components";

interface ISearchTrackerCreationDropdownProps {
    children: ReactNode;
    campaignDataForDropDown: IDescriptionDropdownItemProps[];
    buttonWidth?: string;
    containerClass?: string;
    dropdownPopupPlacement?: string;
    onDropDownToggle?: (isOpen) => void;
    hideNotification?: boolean;
    appendTo?: string;
    isDisabled?: boolean;
    iconColor?: string;
    handleCampaignTypeClick?: (id: string) => void;
}

export const SearchTrackerCreationDropdown: React.FC<ISearchTrackerCreationDropdownProps> = ({
    children,
    campaignDataForDropDown,
    containerClass,
    dropdownPopupPlacement,
    isDisabled = false,
    appendTo,
    handleCampaignTypeClick,
}) => {
    const cssClassContainer = `DropdownContent-container search-tracker-description-dropdown ${containerClass}`;
    const child = children?.constructor === Array ? children[0] : children;
    const handleCampaignClick = (item: IDescriptionDropdownItemProps) => {
        handleCampaignTypeClick?.(item.id as string);
    };
    const buildMenuItems = (campaignData: IDescriptionDropdownItemProps[]): JSX.Element[] => {
        return campaignData.map((data, index) => {
            const { className, disabled, id, title, description, iconName, iconColor } = data;
            return (
                <DescriptionDropdownItem
                    key={index}
                    disabled={disabled}
                    className={className}
                    id={id}
                    title={title}
                    description={description}
                    iconName={iconName}
                    iconColor={iconColor}
                />
            );
        });
    };

    return (
        <div>
            <Dropdown
                width={328}
                appendTo={appendTo}
                cssClassContainer={cssClassContainer}
                dropdownPopupPlacement={dropdownPopupPlacement}
                disabled={isDisabled}
                onClick={handleCampaignClick}
            >
                {[child, ...buildMenuItems(campaignDataForDropDown)]}
            </Dropdown>
        </div>
    );
};
